<ng-container *ngIf="list">
  <div class="container" *ngIf="!isDesktop">
    <div class="title-container">
      <p class="title">Related Product</p>
    </div>

    <div class="list">
      <shared-product-list-item
        *ngFor="let item of relatedProducts"
        [product]="item"
      ></shared-product-list-item>
    </div>
  </div>

  <div class="container" *ngIf="isDesktop && featuredSliderConfig">
    <shared-featured-view
      title="Related Products"
      [config]="featuredSliderConfig"
      [cards]="relatedProducts"
    ></shared-featured-view>
  </div>
</ng-container>
